module.exports = __webpack_public_path__ + "static/zablocie-concept-9ab3fe90ee82bcbbb37e687c275e0a68.png";